module.exports = __webpack_public_path__ + "img/element-icons-logo-hbo.97d0ca20.svg";